import { RuleConditionFields } from './types'

export const supportedOperators: {
  label: string
  value: string
  allowMultipleValues: boolean
  showEmpty: boolean
}[] = [
  { label: 'is equal to', value: '==', allowMultipleValues: false, showEmpty: true },
  { label: 'is not equal to', value: '!=', allowMultipleValues: false, showEmpty: true },
  { label: 'has any of the following', value: 'in', allowMultipleValues: true, showEmpty: true },
  { label: 'has none of the following', value: 'not_in', allowMultipleValues: true, showEmpty: true },
  { label: 'contains', value: 'includes_substring', allowMultipleValues: false, showEmpty: false },
  { label: 'does not contain', value: 'excludes_substring', allowMultipleValues: false, showEmpty: false },
  { label: 'is greater than', value: '>', allowMultipleValues: false, showEmpty: false },
  { label: 'is less than', value: '<', allowMultipleValues: false, showEmpty: false }
]

export const findFieldByValue = (value: string, fields: RuleConditionFields[]): RuleConditionFields | undefined => {
  return fields.find((field) => field.value === value)
}
